import type { Client, RequestContext } from "../client";
import type { LicenseResource, LicenseStatusResource, LicenseUsageResource } from "../resources";
import type { LicensedFeatures } from "../resources/licensedFeatures";

export class LicenseRepository {
    constructor(
        private readonly client: Client,
        private readonly requestContext: RequestContext
    ) {}

    getCurrent() {
        return this.client.get<LicenseResource>(this.requestContext, this.client.getLink("CurrentLicense"));
    }

    async modifyCurrent(resource: LicenseResource): Promise<LicenseResource> {
        const result = await this.client.update(this.requestContext, resource.Links.Self, resource);
        this.client.dispatchEvent({ type: "LicenseModified" });
        return result;
    }

    getCurrentStatus() {
        return this.client.get<LicenseStatusResource>(this.requestContext, this.client.getLink("CurrentLicenseStatus"));
    }

    getCurrentUsage() {
        return this.client.get<LicenseUsageResource>(this.requestContext, this.client.getLink("CurrentLicenseUsage"));
    }

    getFeatures() {
        return this.client.get<LicensedFeatures>(this.requestContext, "~/api/licenses/licenses-current-features");
    }
}
